const initialState = {
    data: [], 
    add:[],
    view:[],
    
  
  };
  
  const SupDocumentsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_ADD_SUCCESS':
            return {... state, add:action.payload};
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupDocumentsReducers;
  
  